import {
  IAsistenciaProyectada,
  QUERY_ASISTENCIAS_EN_RANGO,
  QUERY_OBTENER_ASISTENCIA_POR_ID,
  QUERY_OBTENER_LISTAS_ASISTENCIAS_PROYECTADAS,
  useListarAsistenciasEnRango,
} from "../../services/asistenciaServicios";
import ServerErrorModal from "../organisms/ServerErrorModal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  reagendarHotel,
  useBuscarAgendamientoDeReservaHotel,
} from "../../services/agendamientosHotelServicios";
import ReagendamientoModal from "./ReagendamientoModal";
import { haceUnAno, stringADate, unAnoMas } from "../../utils/dateUtils";

function ReagendamientoHotelModal({
  itemAsistencia,
  onClose,
  fecha,
  idReserva,
}: {
  itemAsistencia: IAsistenciaProyectada;
  idReserva: string;
  fecha: Date;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();

  const inicioRangoAsistencias = haceUnAno();
  const finRangoAsistencias = unAnoMas();

  const {
    data: agendamientoHotel,
    isLoading: isLoadingAgendamientoHotel,
    isError: isErrorAgendamientoHotel,
  } = useBuscarAgendamientoDeReservaHotel(idReserva, true);

  const {
    data: asistencias,
    isLoading: isLoadingAsistencias,
    isError: isErrorAsistencias,
  } = useListarAsistenciasEnRango(
    inicioRangoAsistencias,
    finRangoAsistencias,
    itemAsistencia.idMascota
  );

  const mutacionReagendarHotel = useMutation(reagendarHotel, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_ASISTENCIAS_EN_RANGO]);
      queryClient.invalidateQueries([
        QUERY_OBTENER_LISTAS_ASISTENCIAS_PROYECTADAS,
      ]);
      queryClient.invalidateQueries({
        queryKey: [QUERY_OBTENER_ASISTENCIA_POR_ID],
        refetchType: "none",
      });
      onClose();
    },
  });

  const onGuardarClick = (fechasReemplazadas: Map<string, string>) => {
    if (!agendamientoHotel) return;
    mutacionReagendarHotel.mutate({
      idAgendamiento: agendamientoHotel.id,
      request: {
        fechas: Object.fromEntries(fechasReemplazadas),
        idReservaHotel: idReserva,
      },
    });
  };

  const isError =
    isErrorAsistencias ||
    isErrorAgendamientoHotel ||
    mutacionReagendarHotel.isError;

  const fetchIsLoading =
    isLoadingAgendamientoHotel || isLoadingAsistencias;

  const fechasOcupadas = (asistencias || []).map((asistencia) =>
    stringADate(asistencia.fecha)
  );

  if (isError) {
    return <ServerErrorModal onClose={onClose} />;
  }

  return (
    <ReagendamientoModal
      fechasIsLoading={fetchIsLoading}
      guardando={mutacionReagendarHotel.isLoading}
      onGuardar={onGuardarClick}
      onClose={onClose}
      fechasOcupadas={fechasOcupadas}
      fecha={fecha}
      itemAsistencia={itemAsistencia}
      maxDate={stringADate(finRangoAsistencias)}
    />
  );
}

export default ReagendamientoHotelModal;
